// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2tKhw","dragIcon":"SortableItem_dragIcon__SqHbI","disabled":"SortableItem_disabled__1-AzG"};